<template>
  <div class="flex items-center">
    <input :id="radioId" type="radio" @click="$emit('clicked', localValue);" v-model="localValue" :value="radioValue" :name="name" :class="[color === 'blue' ? ' ring-brand-blue text-brand-blue border-brand-blue border-2' : 'ring-brand-orange text-brand-orange border-brand-orange border-2 focus:border-0']" class="w-5 h-5 cursor-pointer focus:ring-4 ring-opacity-25 form-radio focus:outline-none bg-gray-50">
    <label class="ml-2 cursor-pointer" :for="radioId">{{ label }}</label>
  </div>
</template>

<script>
export default {

    emits: ['update:modelValue', 'clicked'],

    props: {
        name: {
            type: String,
            required: true
        },
        color: {
          type: String,
          default: 'blue'
        },
        radioId: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        modelValue: {
            type: String,
            required: true
        },
        radioValue: {
            type: String,
            required: true
        }
    },

    computed: {
        localValue: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            }
        }
    }
}
</script>

<style>

</style>
